import React, { FC } from 'react';
import { ArticleData } from '../../shared/types';
import { InitialProps } from '../../shared/types/initialProps';
import { RootContentTypes } from '../constants';
import GuideArticle from './GuideArticle/component';
import Home from './Home/component';
import ArticleCategory from './ArticleCategory/component';
import Layout from './shared/Layout';

const rootComponentMapperByType: { [key in RootContentTypes]: FC<any> } = {
  [RootContentTypes.ARTICLE]: GuideArticle,
  [RootContentTypes.CATEGORY]: ArticleCategory,
  [RootContentTypes.HOMEPAGE]: Home,
};

const App: FC<Required<InitialProps>> = (props) => {
  const { user, data, currencyObj, categories, topArticles, type, builderPublicKey } = props;
  const author = type === RootContentTypes.ARTICLE ? (data as ArticleData)?.data?.author?.value.data : undefined;
  const RootComponent = rootComponentMapperByType[type];

  return (
    <Layout categories={categories} topArticles={topArticles} user={user} author={author}>
      <RootComponent data={data as any} currencyObj={currencyObj} builderPublicKey={builderPublicKey} />
    </Layout>
  );
};

export default App;
